import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { ObsService } from '../../core/http/obs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { SendReviewComponent } from '../../shared/components/send-review/send-review.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-lab-result',
  templateUrl: './lab-result.component.html',
  styleUrls: ['./lab-result.component.scss'],
})
export class LabResultComponent implements OnInit {
  isLoading = true;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  data: any = [];
  tableData: any = [];
  samples: any = [];
  Success;
  billId;
  id: string;
  message;
  record: any = [];
  templates: any = [];
  startdate = '';
  enddate = '';
  details;
  isSelected: boolean = true;
  verifyLoad: boolean = false;
  role;
  pass: boolean = true;
  statusLoad = false;
  date = new Date();
  return;
  resultId;
  patient: any = [];

  Template_Text = '';

  style = {
    height: '300px',
  };

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '300px',
    maxHeight: '300px',
    width: 'auto',
    minWidth: 'auto',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat'],
    ],
  };

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl('', Validators.required),
    result_id: new FormControl('', Validators.required),
    bill_id: new FormControl(''),
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private obs: ObsService,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.role = localStorage.getItem('role');
    this.id = this.activatedRoute.snapshot.paramMap.get('billId');
    console.log(this.id);
    console.log(this.role);

    if (this.role == 'Lab Scientist') {
      this.pass = false;
    } else {
      this.pass = true;
    }
    console.log(this.pass);

    this.sample.getResultsById(this.id).subscribe(
      (resSuccess: any) => {
        this.tableData = resSuccess.data.filter(
          (t) =>
            t.department_name == 'LABORATORY' && t.sample_acknowledged == 'Y'
        );
        console.log(this.tableData);
        // this.data = resSuccess
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.setting.getPatientByBillId(this.id).subscribe(
      (resSuccess: any) => {
        this.patient = resSuccess;
        console.log(this.patient);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  getResult() {
    this.sample.getResultsById(this.id).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess.data.filter(
          (t) =>
            t.department_name == 'LABORATORY' && t.sample_acknowledged == 'Y'
        );
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getTemplate(code) {
    this.sample.getTemplate(code).subscribe(
      (resSuccess) => {
        this.templates = resSuccess;
        console.log(this.templates);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getDetails(result_id) {
    console.log('waiting');
    this.sample.getdetails(result_id).subscribe(
      (resSuccess) => {
        this.details = resSuccess;
        this.Template_Text = this.details.data;
        console.log(this.details);
        console.log('wait');
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  backs() {
    this.router.navigateByUrl('/encounters');
  }
  getDocByServiceId(id) {
    this.setting.getDocByServiceId(id).subscribe(
      (resSuccess: any) => {
        this.templates.push(resSuccess);
        console.log(resSuccess);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  addRecord(item) {
    this.record = item;
    if (item.service_name === 'Obstetric') {
      this.obs.addItem(item);
      this.router.navigateByUrl('/obs', { state: { patient: item } });
    } else {
      this.mode = 'wiz';
      this.Errors = '';
      this.isSelected = true;
      // this.getTemplate(item.service_code);
      this.getDetails(item.result_id);
      this.getDocByServiceId(item.service_code);
      this.resultId = item.result_id;
      this.stateForm.patchValue({
        sample_id: item.sample_id,
        format_code: item.format_code,
        result_id: item.result_id,
        bill_id: item.bill_id,
      });
    }
    console.log(item);
  }
  back() {
    this.mode = 'form';
    this.Template_Text = '';
    this.isSelected = true;
    this.templates = [];
  }

  verify() {}

  SendReviewAction(item) {
    this.record = item;
    const data = { resultId: item?.result_id, body: this.Template_Text };
    this.modal.openModal(SendReviewComponent, 'modal', data);
    console.log(item?.result_id);
  }
  SendReview() {
    const data = { resultId: this.record.result_id, body: this.Template_Text };
    this.modal.openModal(SendReviewComponent, 'modal', data);
    console.log(this.record.result_id);
  }

  pushOnline() {
    this.sample
      .pushOnline(
        this.record.result_id,
        '',
        '',
        JSON.stringify([this.record.result_id]),
        '',
        '',
        '',
        ''
      )
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.isSaveLoading = false;
          console.log(resSuccess);

          if (this.message.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  status() {
    this.statusLoad = true;
    this.getDetails(this.resultId);
    this.sample.checkStatus(this.record.result_id).subscribe(
      (resSuccess: any) => {
        this.statusLoad = false;
        this.return = resSuccess;
        if (this.return.IsFinalized) {
          this._snackBar.open('STATUS: finalized', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this._snackBar.open('STATUS not finalized', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }

        console.log(resSuccess);
      },
      (resErr) => {
        this.statusLoad = false;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }

  done() {
    this.mode = 'form';
    this.stateForm.patchValue({
      formatstr: this.Template_Text.replace(/"/g, "'"),
    });
    console.log(this.stateForm.value);
    this._snackBar.open('Template Added Successfully', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text.replace(/"/g, "'");
    this.isSelected = false;
    console.log(this.Template_Text);
  }

  updateIsVerifeid() {
    this.verifyLoad = true;
    const is_verify_action = true;
    const is_collect_action = false;
    const is_acknowledge_action = false;
    const { sample_id, bill_id } = this.stateForm.value;
    this.sample
      .updateIsVerified(
        sample_id,
        bill_id,
        is_collect_action,
        is_acknowledge_action,
        is_verify_action
      )
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.verifyLoad = false;
          console.log(resSuccess);
          // window.location.reload();

          if (this.message.success) {
            this.stateForm.reset();
            this.getResult();
            this._snackBar.open('Verified Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this.Errors = resErr;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  Submit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultDetail(result_id, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          this.getResult();
          this.stateForm.reset();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        this._snackBar.open('error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  onSubmit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultTemplate(sample_id, format_code, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          this.getResult();
          this.stateForm.reset();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        this._snackBar.open('error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }
}
